/**
 * Plattform-Erkennung + API-Base-URL.
 *
 * In der iOS/Android-App (Capacitor) laeuft die Webapp im WebView unter
 * `capacitor://localhost` — API-Calls muessen auf die echte Produktions-URL
 * gehen. Fuer Dev auf dem Mac bleibt Same-Origin (Vite-Proxy oder
 * VITE_BACKEND_URL).
 */

export const isNative =
  typeof window !== "undefined" &&
  (window as unknown as { Capacitor?: { isNativePlatform: () => boolean } })
    .Capacitor?.isNativePlatform() === true;

const PROD_API = "https://parble.app";

export function apiBase(): string {
  if (isNative) return PROD_API;
  return (
    (import.meta as unknown as { env?: { VITE_BACKEND_URL?: string } }).env
      ?.VITE_BACKEND_URL ?? ""
  );
}
